import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PropertyLinkService {
  constructor() {}

  returnPropertyLink(neighborhood, city, state, pid, address) {
    var propertyLink = [
      'explore/#!/property/analysis/',
      neighborhood,
      '-',
      city.replace(/\s+/gi, '-'),
      '-',
      state,
      '/',
      address.replace('#', '-'),
      '/home/',
      pid,
    ].join('');
    propertyLink = propertyLink
      .toLowerCase()
      .replace(/\s+/gi, '-')
      .replace(/[&,+()$~%.'":*?<>{}]/g, '');
    return propertyLink;
  }
}
